import useAppSettings from "../contexts/app/appSettings";

/** Reads the shared brand logo URL from `AppSettingsProvider` (one source of truth for menu + watermarks). */
export function useCompanyBrandLogoSrc(): {
  logoSrc: string;
  onLogoImgError: () => void;
  hasCompanyLogo: boolean;
} {
  const { brandLogoSrc, onBrandLogoImgError, hasCompanyLogo } = useAppSettings();
  return {
    logoSrc: brandLogoSrc,
    onLogoImgError: onBrandLogoImgError,
    hasCompanyLogo,
  };
}
